import { useNavigate } from "react-router-dom"
import { Modal, ModalId } from "../../../../../features/ui"
import { RoutePath } from "../../../../../features/routes"

export const CreateCustomerTypeModal = () => {
    const navigate = useNavigate()

    const onSubmitManual = () => navigate(RoutePath.CREATE)
    
    const onSubmitImport = () => navigate(RoutePath.IMPORT)

    return (
        <Modal
            modalId={ModalId.CREATE_CUSTOMER_TYPE}
            title={`Crear Lista de Precios`}
            submitLabel="Crear Manualmente"
            cancelLabel="Importar Archivo"
            widthSize="s"
            onSubmit={onSubmitManual}
            onCancel={onSubmitImport}
        >
            <p>Seleccione cómo desea crear la nueva lista de precios.</p>
        </Modal>
    )
}
